import React from 'react';
import { motion } from 'framer-motion';
export function CTA() {
  return <section className="py-32 relative z-20 overflow-hidden" data-id="element-53">
      <div className="absolute inset-0 bg-gradient-to-r from-[#7c5cfc]/20 via-[#22d3ee]/20 to-[#ff2d8a]/20" data-id="element-54" />
      <div className="absolute inset-0 backdrop-blur-3xl" data-id="element-55" />

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-56">
        <motion.h2 className="text-5xl md:text-7xl font-display font-black text-white mb-8" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-57">
          מוכנים לבנות משהו יוצא דופן?
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-58">
          <a href="#contact" className="inline-block px-10 py-5 bg-white text-[#0a0a0f] text-xl font-bold rounded-full hover:scale-105 hover:shadow-[0_0_40px_rgba(255,255,255,0.3)] transition-all duration-300" data-id="element-59">
            בואו נדבר
          </a>
        </motion.div>
      </div>
    </section>;
}